import React, { useState } from "react";
import { GuaranteeViewData } from "./GuaranteeDataModel";

//icons
import ChatIcon from "../../assets/Icon_Chat.png";
import { localizedFormatDate } from "helpers/userLocale";
import { parseISO } from "date-fns";
import { PopoutImage } from "./GuaranteePanelReportSummary";
import EyeIcon from "../../assets/Icon_Password_Eye.png";
import maskSensitiveInfo from "components/helpers/maskSensitiveInfo";
import "./GuaranteePanelDocument.scss"
type Props = {
  details: GuaranteeViewData;
  report:boolean;
};

const GuaranteePanelDocument: React.FC<Props> = ({ details,report=false }) => {
  const [eye, setEye] = useState(false)
  return (
    <div className="DocumentSection">
      {report?<h2>ID Document</h2>:<h4>ID Document</h4>}
      <table className={`ViewTable ${report?'increase-font':''}`}>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th>Details</th>
            {/* <th>Status</th> */}
            {/* <th>&nbsp;</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tax ID </td>
            <td className="taxId">
              {
                details?.taxId ?
                  <>
                    {maskSensitiveInfo(details?.taxId, eye)}
                    <img
                      className="tax-img"
                      src={EyeIcon}
                      alt="Toogle tax ID"
                      onClick={() => setEye(prevState => !prevState)}
                    />
                  </>
                  : "-"
              }
            </td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Document type </td>
            <td>{details.document?.documentType ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Issuing country</td>
            <td>{details.document?.documentCountryOfIssue ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Document number</td>
            <td>{details.document?.documentNumber ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Document expiration date</td>
            <td>
              {details.document?.documentExpiryDate
                ? localizedFormatDate(
                  parseISO(details.document.documentExpiryDate)
                )
                : "-"}
            </td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Date of issue</td>
            <td>
              {details.document?.documentIssueDate
                ? localizedFormatDate(
                  parseISO(details.document.documentIssueDate)
                )
                : "-"}
            </td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Date of birth</td>
            <td>
              {details.document?.dateOfBirth
                ? localizedFormatDate(parseISO(details.document?.dateOfBirth))
                : "-"}
            </td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Surname</td>
            <td>{details.document?.lastName ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Full name</td>
            <td>{details.document?.fullName ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
          <tr>
            <td>Age</td>
            <td>{details.document?.age ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>

          <tr>
            <td>Age at issue</td>
            <td>{details.document?.ageAtIssue ?? "-"}</td>
            {/* <th>&nbsp;</th> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>

          <tr>
            <td>Years since issue</td>
            <td>{details.document?.yearsSinceIssue ?? "-"}</td>
            {/* <td>&nbsp;</td> */}
            {/* <td><img src={ChatIcon} alt="ChatIcon" /></td> */}
          </tr>
        </tbody>
      </table>
      {details.documentFrontImageURI && (
        <PopoutImage
          url={details.documentFrontImageURI}
          className="updated-SummaryImage"
        />
      )}
      {details.documentBackImageURI && (
        <PopoutImage
          url={details.documentBackImageURI}
          className="updated-SummaryImage"
        />
      )}
    </div>
  );
};

export default GuaranteePanelDocument;
